module.exports = __webpack_public_path__ + "img/IMG_0887.faad340c.jpg";